import Layout from '@/components/layout/Layout'
import MainHeading from '@/components/common/MainHeading'

const OdDetail: React.FC = () => {

    return (
        <Layout>
            <div className="space-y-6">
                <div className="flex items-center justify-between">
                    <MainHeading title="OD Detail" />
                </div>

            </div>
        </Layout>
    )
}


export default OdDetail
